import { Temporal } from '@insio/dates';
import { useFormatShortDate } from '../../../../hooks/dates-hooks';
import type { FormatterProps } from '../types/editor-config';
import { ReactNode } from 'react';

export function DateFormatter({ value }: FormatterProps): ReactNode {
  const formatShortDate = useFormatShortDate();

  const text = value instanceof Temporal.PlainDate ? formatShortDate(value) : String(value);

  return (
    <span className='inline-flex flex-col gap-2xs items-start'>
      <span>{text}</span>
    </span>
  );
}
